module.exports = __webpack_public_path__ + "media/images/MyEtherWallet-e6acd346.svg";